<template>
  <el-form>
    <el-form-item :class="className">
      <mark
        class="_mark"
        v-show="showSeason"
        @click.stop="showSeason = false"
      ></mark>
      <el-input
        placeholder="请选择季度"
        v-model="showValue"
        size="mini"
        @focus="showSeason = true"
        :disabled="disabled"
      >
        <i slot="prefix" class="el-input__icon el-icon-date"></i>
      </el-input>
      <el-card class="box-card" v-show="showSeason" ref="showPanel">
        <div x-arrow="" class="popper__arrow" style="left: 35px"></div>
        <div slot="header" class="clearfix yearBtn">
          <button
            type="button"
            aria-label="前一年"
            class="
              el-picker-panel__icon-btn
              el-date-picker__prev-btn
              el-icon-d-arrow-left
            "
            @click="prev"
          ></button>
          <span role="button" class="el-date-picker__header-label"
            >{{ year }}年</span
          >
          <button
            type="button"
            aria-label="后一年"
            class="
              el-picker-panel__icon-btn
              el-date-picker__next-btn
              el-icon-d-arrow-right
            "
            @click="next"
          ></button>
        </div>
        <div class="text item">
          <el-button
            type="text"
            size="medium"
            class="_left"
            @click="selectSeason(0)"
            >第一季度</el-button
          >
          <el-button
            type="text"
            size="medium"
            class="_right"
            @click="selectSeason(1)"
            >第二季度</el-button
          >
          <el-button
            type="text"
            size="medium"
            class="_left"
            @click="selectSeason(2)"
            >第三季度</el-button
          >
          <el-button
            type="text"
            size="medium"
            class="_right"
            @click="selectSeason(3)"
            >第四季度</el-button
          >
        </div>
      </el-card>
    </el-form-item>
  </el-form>
</template>
<script>
import $ from "jquery";
export default {
  props: {
    valueArr: {
      default: () => {
        return ["01-03", "04-06", "07-09", "10-12"];
      },
      type: Array,
    },
    getValue: {
      default: () => {},
      type: Function,
    },
    defaultValue: {
      type: String,
      default: "",
    },
    disabled: "",
    villageForm: {
      default: () => {
        return {};
      },
      type: Object,
    },
    date: {},
    className: {},
  },
  data() {
    return {
      showSeason: false,
      season: "",
      year: new Date().getFullYear(),
      showValue: "",
      disabled0: true,
      disabled1: true,
      disabled2: true,
      disabled3: true,
    };
  },
  created() {
    if (this.defaultValue) {
      let value = this.defaultValue;
      let arr = value.split("-");
      this.year = arr[0].slice(0, 4);
      let str = arr[0].slice(4, 6) + "-" + arr[1].slice(4, 6);
      let arrAll = this.valueArr;
      this.showValue = `${this.year}年${arrAll.indexOf(str) + 1}季度`;
    }
    if (+this.$formatDate(new Date(this.date), "MM") <= 3) {
      this.showValue = `${this.$formatDate(
        new Date(this.date),
        "yyyy"
      )}年第一季度`;
    } else if (+this.$formatDate(new Date(this.date), "MM") <= 6) {
      this.showValue = `${this.$formatDate(
        new Date(this.date),
        "yyyy"
      )}年第二季度`;
    } else if (+this.$formatDate(new Date(this.date), "MM") <= 9) {
      this.showValue = `${this.$formatDate(
        new Date(this.date),
        "yyyy"
      )}年第三季度`;
    } else if (+this.$formatDate(new Date(this.date), "MM") <= 12) {
      this.showValue = `${this.$formatDate(
        new Date(this.date),
        "yyyy"
      )}年第四季度`;
    }
  },
  watch: {
    date(v) {
      if (+this.$formatDate(new Date(v), "MM") <= 3) {
        this.showValue = `${this.$formatDate(
          new Date(this.date),
          "yyyy"
        )}年第一季度`;
      } else if (+this.$formatDate(new Date(v), "MM") <= 6) {
        this.showValue = `${this.$formatDate(
          new Date(this.date),
          "yyyy"
        )}年第二季度`;
      } else if (+this.$formatDate(new Date(v), "MM") <= 9) {
        this.showValue = `${this.$formatDate(
          new Date(this.date),
          "yyyy"
        )}年第三季度`;
      } else if (+this.$formatDate(new Date(v), "MM") <= 12) {
        this.showValue = `${this.$formatDate(
          new Date(this.date),
          "yyyy"
        )}年第四季度`;
      }
    },
  },
  mounted() {
    const _this = this;
    document.addEventListener(
      "click",
      (e) => {
        if (e.path) {
          let show = false;
          for (let i = 0; i < e.path.length; i++) {
            if (e.path[i].getAttribute && e.path[i].getAttribute("class")) {
              if (
                e.path[i].getAttribute("class").indexOf(this.className) > -1
              ) {
                show = true;
                break;
              }
            }
          }
          this.showSeason = show;
        }
      },
      true
    );
    this.getYear();
  },
  methods: {
    one() {
      this.showSeason = false;
    },
    prev() {
      this.year = this.year * 1 - 1;
      this.getYear();
    },
    next() {
      this.year = this.year * 1 + 1;
      this.getYear();
    },
    reast() {
      this.showValue = "";
    },
    getYear() {
      if (this.year > new Date().getFullYear()) {
        this.disabled0 = true;
        this.disabled1 = true;
        this.disabled2 = true;
        this.disabled3 = true;
      } else if (this.year == new Date().getFullYear()) {
        if (new Date().getMonth() > "03") {
          this.disabled0 = false;
          this.disabled1 = true;
          this.disabled2 = true;
          this.disabled3 = true;
        } else if (new Date().getMonth() > "06") {
          this.disabled0 = false;
          this.disabled1 = false;
          this.disabled2 = true;
          this.disabled3 = true;
        } else if (new Date().getMonth() > "09") {
          this.disabled0 = false;
          this.disabled1 = false;
          this.disabled2 = false;
          this.disabled3 = true;
        } else {
          this.disabled0 = true;
          this.disabled1 = true;
          this.disabled2 = true;
          this.disabled3 = true;
        }
      } else {
        this.disabled0 = false;
        this.disabled1 = false;
        this.disabled2 = false;
        this.disabled3 = false;
      }
    },
    selectSeason(i) {
      let that = this;
      that.season = i + 1;
      let arr = that.valueArr[i].split("-");
      that.getValue(that.year + arr[0] + "-" + that.year + arr[1]);
      that.showSeason = false;
      if (this.season == 1) {
        this.showValue = `${this.year}年第一季度`;
      } else if (this.season == 2) {
        this.showValue = `${this.year}年第二季度`;
      } else if (this.season == 3) {
        this.showValue = `${this.year}年第三季度`;
      } else if (this.season == 4) {
        this.showValue = `${this.year}年第四季度`;
      }
      that.sendMsg();
    },
    getLastDay(year, month) {
      var new_year = year;
      var new_month = month++;
      if (month > 12) {
        new_month -= 12;
        new_year++;
      }
      var new_date = new Date(new_year, new_month, 1);
      return new Date(new_date.getTime() - 1000 * 60 * 60 * 24).getDate();
    },
    sendMsg() {
      if (this.showValue.indexOf("一") > -1) {
        this.$emit("func", `${this.year}/01/01`);
      } else if (this.showValue.indexOf("二") > -1) {
        this.$emit("func", `${this.year}/04/01`);
      } else if (this.showValue.indexOf("三") > -1) {
        this.$emit("func", `${this.year}/07/01`);
      } else if (this.showValue.indexOf("四") > -1) {
        this.$emit("func", `${this.year}/10/01`);
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
._mark {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0);
  z-index: 999;
  width: 200px;
}

.el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
  width: 400px;
}

.yearBtn {
  text-align: center;
  padding: 0;
}

.box-card {
  width: 322px;
  padding: 0 3px 20px;
  margin-top: 10px;
  position: fixed;
  z-index: 9999;
}

.el-date-picker__header-label {
  padding: 0 25px;
}

.text.item {
  text-align: center;
}

.text.item >>> .el-button {
  width: 40%;
  color: #606266;
}

::v-deep .el-input--small .el-input__inner {
  height: 41px;
}

/deep/.el-form-item {
  margin: 0 !important;
}

/deep/.el-form {
  padding: 0 !important;
  width: 180px;
}

/deep/.el-input {
  width: 180px !important;
}

.el-button--text {
  color: #606266;
}

>>> .el-form-item__content {
  line-height: 32px;
}

.el-card::after {
  margin-left: -6px;
  width: 0;
  height: 0;
  position: absolute;
  top: -11px;
  left: 35px;
  border-top: 5px solid rgba(0, 0, 0, 0);
  border-right: 5px solid rgba(0, 0, 0, 0);
  border-bottom: 5px solid #fff;
  border-left: 5px solid rgba(0, 0, 0, 0);
  box-sizing: content-box;
}

.el-card::after {
  content: '';
  border-width: 6px;
}

.el-card {
  overflow: inherit;
}

>>> .el-input__inner {
  width: 180px !important;
}

/deep/.el-input__prefix {
  position: relative;
}

/deep/.el-input__icon {
  position: absolute;
  top: 0;
}

.text {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/weekSelect.vue